import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts'
import type { PerModelStat } from '@ekorank/shared'
import { MODEL_DISPLAY, modelLabel } from '@/lib/modelDisplay'

interface Props {
  perModel: PerModelStat[]
}

export function ModelBreakdown({ perModel }: Props) {
  if (perModel.length === 0) {
    return null
  }
  const chartData = perModel.map((m) => ({
    label: modelLabel(m.model),
    rate: m.mentionRate,
    color: MODEL_DISPLAY[m.model]?.color ?? '#908fa0',
    checks: m.checks,
    mentions: m.mentions,
  }))

  return (
    <div className="bg-surface-container rounded-xl border border-outline-variant/10 p-4 sm:p-6 mb-6 sm:mb-10">
      <h3 className="text-sm font-mono text-outline uppercase tracking-widest mb-1">Mention Rate by AI Model</h3>
      <p className="text-xs text-outline mb-6">% of checks where each engine mentions you</p>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#353534" />
          <XAxis dataKey="label" tick={{ fill: '#908fa0', fontSize: 11 }} />
          <YAxis tick={{ fill: '#908fa0', fontSize: 11 }} unit="%" domain={[0, 100]} />
          <Tooltip
            contentStyle={{ background: '#201f1f', border: '1px solid #464554', borderRadius: 4 }}
            labelStyle={{ color: '#e5e2e1' }}
            formatter={(value: number, _name, item) => {
              const payload = item.payload as { checks: number; mentions: number }
              return [`${value}% (${payload.mentions}/${payload.checks})`, 'Rate']
            }}
          />
          <Bar dataKey="rate" radius={[4, 4, 0, 0]}>
            {chartData.map((d) => (
              <Cell key={d.label} fill={d.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
